import { Reducer } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { ActionsUnion, createAction } from '../../utils/action-helper';

const FETCH_COORDINATES_REQUEST: any = 'coordinates/FETCH_COORDINATES_REQUEST';
const FETCH_COORDINATES_SUCCESS = 'coordinates/FETCH_COORDINATES_SUCCESS';
const FETCH_COORDINATES_FAIL = 'coordinates/FETCH_COORDINATES_FAIL';
const LOCATION_ERROR_MESSAGE = 'coordinates/LOCATION_ERROR';
const SET_LOCATION = 'coordinates/SET_LOCATION';
const COORDINATES_SELECTED_LOCATION = 'coordinates/COORDINATES_SELECTED_LOCATION';
const apiKey = 'f018c187-ac10-41fb-968b-7250363708d6';

export const actions = {
  fetchCoordinatesRequest: (payload: { location: string }) =>
    createAction(FETCH_COORDINATES_REQUEST, payload),
  fetchCoordinatesSuccess: (payload: { lat: number; lng: number; selects: any[] }) =>
    createAction(FETCH_COORDINATES_SUCCESS, payload),
  fetchCoordinatesFail: (payload: string) => createAction(FETCH_COORDINATES_FAIL, payload),
};

export const setLocationErrorMessage = (payload: string) => ({
  type: LOCATION_ERROR_MESSAGE,
  payload,
});

type CoordinatesLocationType = {
  lat: number | null;
  lng: number | null;
};
type LocationType = {
  coordinatesSelectedLocation: CoordinatesLocationType;
  address: string;
};

export const selectLocation = (payload: LocationType) => ({
  type: COORDINATES_SELECTED_LOCATION,
  payload: {
    coordinatesSelectedLocation: payload.coordinatesSelectedLocation,
    address: payload.address,
  },
});

export const setLocation = (payload: {
  lat: number | null;
  lng: number | null;
  address: string;
}) => ({
  type: SET_LOCATION,
  payload: {
    coordinatesSelectedLocation: {
      lat: payload.lat,
      lng: payload.lng,
    },
    address: payload.address,
  },
});

export interface IInitialState {
  coordinates: { lat: number; lng: number } | null;
  selects: any[] | null;
  loading: boolean;
  error: string | null;
  locationErrorMessage: string;
  coordinatesSelectedLocation: { lat: number | null; lng: number | null };
  address: string;
}

const initialState: IInitialState = {
  coordinates: null,
  selects: [{ GeoObject: { name: '' } }],
  loading: false,
  error: null,
  locationErrorMessage: '',
  coordinatesSelectedLocation: { lat: null, lng: null },
  address: '',
};

export const reducer: Reducer<IInitialState> = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_COORDINATES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_COORDINATES_SUCCESS:
      return {
        ...state,
        loading: false,
        coordinatesSelectedLocation: { lat: action.payload.lat, lng: action.payload.lng },
        selects: action.payload.selects,
      };

    case FETCH_COORDINATES_FAIL:
      return { ...state, loading: false, error: action.payload };

    case LOCATION_ERROR_MESSAGE:
      return { ...state, locationErrorMessage: action.payload };

    case SET_LOCATION:
      return {
        ...state,
        coordinatesSelectedLocation: {
          lat: action.payload.lat,
          lng: action.payload.lng,
        },
        address: action.payload.address,
      };

    case COORDINATES_SELECTED_LOCATION:

      return {
        ...state,
        coordinatesSelectedLocation: {
          lat: action.payload.coordinatesSelectedLocation.lat,
          lng: action.payload.coordinatesSelectedLocation.lng,
        },
        address: action.payload.address,
      };

    // Другие экшены
    default:
      return state;
  }
};

export type TActions = ActionsUnion<typeof actions>;

// Функция для получения координат
export async function getCoordinates(location: string) {
  const data = await axios(
    `https://geocode-maps.yandex.ru/1.x/?geocode=${location}&apikey=${apiKey}&format=json`
  );
  if (!data) {
    throw new Error('Network response was not ok');
  }
  return data.data;
}

function* fetchCoordinatesSaga({ payload }: { payload: { location: string } }): any {
  try {
    const data = yield call(() => getCoordinates(payload.location));
    const pos = data.response.GeoObjectCollection.featureMember[0]?.GeoObject?.Point?.pos;

    if (pos) {
      const [lng, lat] = pos.split(' ').map(Number);
      const selects = data.response.GeoObjectCollection.featureMember;
      yield put(actions.fetchCoordinatesSuccess({ lat, lng, selects }));
    } else {
      yield put(actions.fetchCoordinatesFail('Координаты не найдены'));
    }
  } catch (err) {
    yield put(actions.fetchCoordinatesFail(err.message || 'Ошибка сети'));
  }
}

export function* saga() {
  yield takeLatest(FETCH_COORDINATES_REQUEST, fetchCoordinatesSaga);
}
